<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Resultados C3</div>
    </v-card-title>
    <v-card-text>
      <v-container v-if="loading" fluid>
        <v-row align="center" justify="center" style="min-height: 200px">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
            <div class="text-h6 mt-4">Cargando resultados C3...</div>
          </v-col>
        </v-row>
      </v-container>
      <template v-else>
        <v-data-table :headers="headersC3" :items="c3Items" class="transparent" hide-default-footer disable-pagination>
          <template v-slot:[`item.observaciones`]="{ item }">
            <div style="white-space: pre-line">{{ item.observaciones }}</div>
          </template>
          <template v-slot:[`item.resultado`]="{ item }">
            <span>{{ item.resultado }}</span>
          </template>
          <template v-slot:[`item.fechaVigenciaEvaluacionC3`]="{ item }">
            <span>{{ formatFecha(item.fechaVigenciaEvaluacionC3) }}</span>
          </template>
          <template v-slot:[`item.acciones`]="{ item }">
            <v-btn icon color="secondary" small @click="openEditModal(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import { PERFILES } from '../../perfiles'
import { HUMAN_READABLE_DATE_FORMAT } from '@src/const'

const PERFILES_ARMERIA = [
  PERFILES.Armeria,
  PERFILES.ARMERIA_LOC,
  PERFILES['ARMERIA_PASE DE LISTA'],
  PERFILES['ARMERIA_PERSONAL LOC'],
  PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
  PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
]

export default {
  props: {
    personal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      DIALOG_TYPES,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('resultadosPersonalesC3', {
      c3Items: 'getResultados',
    }),
    perfilLogeado() {
      return localStorage.getItem('perfil')
    },
    isPerfilArmeria() {
      return PERFILES_ARMERIA.includes(this.perfilLogeado)
    },
    headersC3() {
      const baseHeaders = [
        { text: 'Resultado', value: 'resultado' },
        { text: 'Fecha de Vigencia', value: 'fechaVigenciaEvaluacionC3' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'acciones', sortable: false },
      ]
      if (this.isPerfilArmeria) {
        return baseHeaders.filter((h) => h.value !== 'acciones' && h.value !== 'resultado')
      }
      return baseHeaders
    },
  },

  methods: {
    ...mapActions('resultadosPersonalesC3', ['fetchResultados']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openEditModal(item) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_RESULTADO_C3,
        props: { resultadoC3: item, idPersonal: this.personal.idPersonal },
      })
    },
    formatFecha(fecha) {
      if (!fecha) return ''
      const fechaNormalizada = fecha.replace('a. m.', 'AM').replace('p. m.', 'PM')
      return moment(fechaNormalizada, 'DD/MM/YYYY hh:mm:ss A').format(HUMAN_READABLE_DATE_FORMAT)
    },
  },

  watch: {
    'personal.idPersonal': {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          this.loading = true
          try {
            await this.fetchResultados(newVal)
          } catch (error) {
            console.error('Error cargando resultados C3:', error)
          } finally {
            this.loading = false
          }
        }
      },
    },
  },
}
</script>
